import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "App-Terms-Sub-Header" }
const _hoisted_2 = { "f-w-700": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("h1", {
        "txt-center": "",
        "m-t-0": ""
      }, "Glossary", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("h2", { "txt-center": "" }, "Dimensions of Entrepreneurial Ability"),
        _createElementVNode("p", { "txt-center": "" }, " This document describes the dimensions of entrepreneurial ability measured in the E4T Entrepreneurial Profile Survey. These dimensions have been determined based on academic research to be the most salient personal characteristics affecting entrepreneurial outcomes. ")
      ], -1)),
      _createVNode(_component_el_divider)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_space, {
        direction: "vertical",
        size: 12
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.heading
            }, [
              _createElementVNode("h3", _hoisted_2, _toDisplayString(item.heading), 1),
              _createElementVNode("p", null, _toDisplayString(item.description), 1)
            ]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}